import { combineReducers } from 'redux'
import featureFlagsDrawerReducer from './drawer'
import addEditFeatureFlagsModalReducer from './addEditModal'
import deleteModalReducer from './deleteModal'

export default combineReducers({
    drawer: featureFlagsDrawerReducer,
    createEditModal: addEditFeatureFlagsModalReducer,
    deleteModal: deleteModalReducer,
})